import styles from "@css/modules/pointsGuide.module.scss"
import { useRef, useState } from "react"
import cn from "classnames"
import { ArrowDown, ArrowLeftThin, Close } from "@css/icons/SVG"
import { Select } from "antd"

const values = new Array(21).fill(0)

export function Step1({ onChange, goNext, lastValue, mobile }) {
    const [value, setValue] = useState(() => lastValue || null)
    const localSetValue = (val) => {
        setValue(val)
        onChange(val)
    }
    const ref = useRef(null)
    const scrollRoot = (right) => {
        const width = ref.current.parentElement.offsetWidth / 2
        ref.current.scrollBy(right ? width : -width, 0)
    }
    return (
        <div className={cn(styles.stepContainer, styles.step1Container)} id="scroll-target">
            <div className={styles.stepContent}>
                <h2>How long do you typically vacation for?</h2>
                <p>Select Number of days</p>
                {mobile ? (
                    <Select
                        allowClear
                        clearIcon={<Close />}
                        onChange={(value) => localSetValue(value)}
                        className={cn(styles.selectField)}
                        name="days"
                        id="daysSelect"
                        value={value}
                        placeholder="Select Number of days"
                        suffixIcon={<ArrowDown />}>
                        {values.map((_, k) => {
                            const i = k + 1
                            return (
                                <Select.Option key={i} value={i}>
                                    {i}
                                </Select.Option>
                            )
                        })}
                    </Select>
                ) : (
                    <div className={styles.scrollWrapper}>
                        <button className={styles.arrow} onClick={() => scrollRoot()}>
                            <ArrowLeftThin />
                        </button>
                        <button className={styles.arrow} onClick={() => scrollRoot(true)}>
                            <ArrowLeftThin />
                        </button>
                        <div ref={ref} className={styles.step1OverButtons}>
                            {values.map((_, k) => {
                                return (
                                    <button
                                        className={cn({
                                            [styles.step1Button]: true,
                                            [styles.step1ButtonActive]: value === k + 1
                                        })}
                                        key={k}
                                        onClick={() => localSetValue(k + 1)}>
                                        {k + 1}
                                    </button>
                                )
                            })}
                        </div>
                    </div>
                )}
                <button className={styles.goNext} onClick={goNext} disabled={!value}>
                    Continue
                </button>
            </div>
        </div>
    )
}
